import { getIsNullish } from '../../../shared/utils/jsUtils';

/**
 * Checks if the promo price is limited by Stripe's minimum price policy.
 * If the promo price is lower than the final price, it means we've reached Stripe's
 * policy of minimum 50 cents price and cannot apply the full promotional discount.
 */
export const isPromoPriceLimited = (
  promoPrice?: number | null,
  finalPrice?: number | null,
) => {
  if (getIsNullish(promoPrice) || getIsNullish(finalPrice)) {
    return false;
  }

  return promoPrice < finalPrice;
};
